import { createContext } from 'react'

export const CashierContext = createContext()
